module.exports = __webpack_public_path__ + "static/media/David_R@3x.ed769dbb.jpg";